import { dateFormatters } from '@frontend/duck-tape';
import { useFeatureValue } from '@frontend/react';
import { Pane } from './Pane';

const FALLBACK_MESSAGE =
  'Our systems are undergoing maintenance to keep things running smoothly. This will be done shortly.';

export const MaintenancePane = () => {
  const { value: maintenanceMode } = useFeatureValue('maintenance_mode');
  const { expires_at, message = FALLBACK_MESSAGE } = maintenanceMode ?? {};

  const messageWithExpiration = expires_at
    ? `${message} Try again after ${dateFormatters['LLLL'](expires_at)}`
    : message;

  return (
    <Pane
      description={messageWithExpiration}
      enableBackgroundColor
      iconName="IconBarrierBlock"
      iconProps={{ color: 'yellow', enableBackgroundColor: true }}
      title="Maintenance"
    />
  );
};
